import React, { useState } from "react";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { LOOP } from "@splidejs/splide";

export default function Reviews() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="container-0">
        <div className="reviews-accordion">
          <button
            className="reviews-toggle"
            onClick={() => setOpen((prev) => !prev)}
            aria-expanded={open}
          >
            Отзывы
          </button>

          <div className={`reviews-wrapper ${open ? "open" : ""}`}>
            <div className="rewiews-container reviews-content">
              <Splide
                options={{
                  rewind: true,
                  width: "100%",
                  gap: "20px",
                  perPage: 3,
                  perMove: 1,
                  autoplay: true,
                  interval: 2500,
                  type: "loop",
                  arrows: true,
                  mediaQuery: "max",
                  breakpoints: {
                    1080: {
                      perPage: 2,
                    },
                    880: {
                      perPage: 2,
                    },
                    425: {
                      perPage: 1,
                    },
                  },
                }}
              >
                <SplideSlide>
                  <div className="rewiews">
                    <div className="rewiews-name">
                      <h3>Мария Ермолаева</h3>
                      <p>29 июня 2022</p>
                    </div>
                    <p className="description">
                      Хожу сюда на капельницы, долго болела спина от сидячей работы.
                      Клинику посоветовала тётя. В первый же день оперативно
                      получила консультацию доктора, и сразу же приступили к
                      лечеению. После третьей капельницы стало гораздо легче.
                      Спасибо за такую атмосферу уюта, заботы и за ваш
                      профессионализм. Особая признательность процедурной медсестре
                      Алие
                    </p>
                  </div>
                </SplideSlide>
                <SplideSlide>
                  <div className="rewiews">
                    <div className="rewiews-name">
                      <h3>​Ольга Шигорина</h3>
                      <p>16 декабря 2022</p>
                    </div>
                    <p>
                      Ставила капельницы от токсикоза, потому что не могла уже ни
                      есть, ни пить, а только лежать в позе эмбриона. Терапевт сразу
                      осмотрела, провела консультацию, и 3 дня капали. Почувствовала
                      себя наконец человеком! Вернулись силы, аппетит. До завершения
                      токсикоза ещё не одна неделя, но если станет хуже прибегу
                      снова на капельницы! Спасибо!
                    </p>
                  </div>
                </SplideSlide>
                <SplideSlide>
                  <div className="rewiews">
                    <div className="rewiews-name">
                      <h3>Зинаида Ивановна</h3>
                      <p>16 сентября 2022</p>
                    </div>
                    <p>
                      Обращались к педиатру Эмине Нурсаидовне. Очень довольны!!!
                      Индивидуальный подход к родителю и ребёнку, осторожное и
                      бережное назначение лекарственных средств только после
                      анализов, «на всякий случай» антибиотики не назначаются. Врач
                      просто звонит в промежутке между приемами, чтобы узнать и
                      проконтролировать самочувствие ребёнка! Это так ценно!!! Такое
                      доброе отношение сейчас, когда все в стрессе и загружены
                      работой, очень редко встретишь! Хочется сказать огромное
                      спасибо всему персоналу клиники за профессионализм, вежливое и
                      радушное общение!!! Всегда приятно, когда тебя встречают с
                      улыбкой!
                    </p>
                  </div>
                </SplideSlide>
                <SplideSlide>
                  <div className="rewiews">
                    <div className="rewiews-name">
                      <h3>​Татьяна Степаненко</h3>
                      <p>30 ноября 2022</p>
                    </div>
                    <p>
                      Все в одном месте, и это здорово! Мужу массаж, мне капельницу
                      с витаминами👍🏻 очень понравилось, что есть детские
                      специалисты, при чем достаточно грамотные😍 рекомендую
                      однозначно! И моя семья еще не раз обратится в это прекрасное
                      место
                    </p>
                  </div>
                </SplideSlide>
                <SplideSlide>
                  <div className="rewiews">
                    <div className="rewiews-name">
                      <h3>Марина Кондрашова</h3>
                      <p>25 января 2025</p>
                    </div>
                    <p>
                      Проходим реабилитацию второй год каждые 3 месяца ! Очень нам все нравится, как организована работа мед персонала, администратора, все четко по времени, что для меня очень важно. Квалифицированный медицинский персонал.
                      Большой спектр услуг. Ребенок бежит с удовольствием , для меня это самое ценное!
                      Отдельное спасибо Сивухе Юлии Валентиновне, педагог с большой буквы! Тренировки АФК проходят в игровой форме с индивидуальным подходом к каждому ребенку!
                      Бухаров Константин Витальевич-профессиональный массажист!
                      Заурова Гульнар Джамалдиновна - логопедические занятия проводит в игровой форме, что очень нравится ребенку.
                      Мы очень любим ходить в «Медмел» спасибо, что открыли такой замечательный медицинский центр рядом с нашим детским садом в морозные дни очень актуально !
                    </p>
                  </div>
                </SplideSlide>
                <SplideSlide>
                  <div className="rewiews">
                    <div className="rewiews-name">
                      <h3>Софият Курганова</h3>
                      <p>18 декабря 2024</p>
                    </div>
                    <p>
                      Отличная клиника, ходим уже не первый год, отзывчивый и вежливый персонал.
                      Рекомендую всем!
                    </p>
                  </div>
                </SplideSlide>
                <SplideSlide>
                  <div className="rewiews">
                    <div className="rewiews-name">
                      <h3>Лилия Арсланова</h3>
                      <p>18 декабря 2024</p>
                    </div>
                    <p>
                    Посещали с ребёнком, сам мед центр и специалисты всё понравилось, доброжелательные и квалифицированные, качество предоставляемых услуг на высоком уровне. Рекомендую.
                    </p>
                  </div>
                </SplideSlide>
                <SplideSlide>
                  <div className="rewiews">
                    <div className="rewiews-name">
                      <h3>V VS</h3>
                      <p>9 апреля 2025</p>
                    </div>
                    <p>
                      Спасибо большое центру я рада что попала к вам
                      Все сотрудники огромные молодцы и вежливые «Дочери 5 лет задержка речи и Рас ...После реабилитации в центре появилась обращенная речь ,слов гораздо больше стало ,каждый день радуюсь новым словам .Я очень этому рада ,спасибо всем большое!
                    </p>
                  </div>
                </SplideSlide>
                <SplideSlide>
                  <div className="rewiews">
                    <div className="rewiews-name">
                      <h3>Лилия</h3>
                      <p>20 января 2025</p>
                    </div>
                    <p>
                      Проходили несколько курсов с дочерью на развитие речи, прошли много процедур. Больше всего нас интересовало БАК процедура, результами довольны.Все наши пожелания учитываются, удобное время подстраивают, персонал вежливый, комфортная обстановка.
                      Сама еще лично прошла БАК процедуру, массаж( очень хорошо делают, сильные руки у массажиста, делает на совесть от души, огромная благодарность), парафин на спину понравилось.
                      Также хочу отметить услуги психолога, которые помогли в решении личных проблем, спасибо большое за профессиональное отношение.
                      Благодарю весь коллектив Медмел!
                      Желаю Вам процветания!
                    </p>
                  </div>
                </SplideSlide>
              </Splide>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
